import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {  ListTableComponent  } from '@ppl/ui';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { LookupService } from '../../../../services/lookup.service';
import {
  DialogConfig,
  DialogService,
} from '../../../../shared/services/dialog.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { ListService } from '../../../../shared/services/list.service';
import { CommonModule } from '@angular/common';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { TimesheetStaffErrorcodeComponent } from "../timesheet-staff-errorcode/timesheet-staff-errorcode.component";
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { SectionsService } from '../../../../services/sections.service';
import { AuthorizationDetailsComponent } from "../../authorizations/authorization-details/authorization-details.component";
import { TimesheetStaffDeniedReasonsComponent } from "../timesheet-staff-deniedreasons/timesheet-staff-deniedreasons.component";
import { TimesheetStaffAuthDataComponent } from "../timesheet-staff-authdata/timesheet-staff-authdata.component";
import { ButtonComponent } from '@ppl/ui';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { UserService } from '../../../../services/user.service';
import CommonUtil from '../../../../shared/authorization/common.util';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { TimesheetEditHistoryViewComponent } from '../timesheet-edit-history-view/timesheet-edit-history-view.component';
import { AuditHistoryComponent } from '../../../../shared/modals/audit-history/audit-history.component';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'ppl-timesheet-detail-view',
  standalone: true,
  imports: [
    CommonModule,
    ListTableComponent,
    NzSelectModule,
    NzFormModule,
    FormsModule,
    NzDividerModule,
    TimesheetNewEntriesComponent,
    TimesheetStaffErrorcodeComponent,
    AuthorizationDetailsComponent,
    TimesheetStaffDeniedReasonsComponent,
    TimesheetStaffAuthDataComponent,
    TimesheetEditHistoryViewComponent,
    AuditHistoryComponent,
    ButtonComponent
  ],
  templateUrl: './timesheet-detail-view.component.html',
  styleUrl: './timesheet-detail-view.component.css',
})
export class TimesheetDetailViewComponent implements OnInit {
  @Input() lineItem?: any;
  @Input() isProviderView?: boolean = false;
  @Input() rowData?: any;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('deniedDialog') deniedDialog!: TemplateRef<any>;
  @ViewChild('authDataDialog') authDataDialog!: TemplateRef<any>;
  @ViewChild('timesheetEditHistoryDialog') timesheetEditHistoryDialog!: TemplateRef<any>;
  @ViewChild('timesheetAuthHistoryDialog') timesheetAuthHistoryDialog!: TemplateRef<any>;
  @ViewChild('derivedElementsDialog') derivedElementsDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;
  // Passed to ppl-authorization-details as an input; never put into the shared selected lead.
  selectedAuthorizationId: any = null;
  @Output() onProcessComplete = new EventEmitter<any>();

  authDetails: any;
  pendedDialogId: any;
  selectedCheckBoxValue: any;
  private groupedTimeoffSource: any;
  private groupedTimeoffData: any[] = [];

  actionButtons: TableRowActionsModel = new TableRowActions({ editHistory: true, auditHistory: true });
  programName: any;
  @Input() timeoffData: any;
  @Input() isTimeOff: any;
  reasonList: any;
  statusList: any;
  timesheetData: any;
  dispositionReason: any;
  timesheetDisposition: any;
  processingStatusList: any;
  action = '';
  errorCodes: any;
  errorcodeData: any;
  deniedData: any;
  authData: any;
  derivedElementsData: any;
  mode = 'view';
  timeEntry = 'timeEntry';
  payPeriod: any[] = [];
  filetredPayPeriod: any;
  @Input() timesheetFor?: string = 'staff';
  disableEditingPendedTimesheet = false;
  @Input() isReadOnly = false;
  selectedTimesheetId: any;
  serviceLocations: LookupValueItem[] = [];
  timeoff_cols = [
    {
      field: 'serviceDate',
      header: 'Service \nDate',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'createdDate',
      header: 'Submission \nDate',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDescription',
      header: 'Service \nCode',
      jsonpath: 'serviceDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'authDesc',
      header: 'Service \nDescription',
      jsonpath: 'authDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time \nIn',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'clockInLocation',
      header: 'Clock In \nLocation',
      jsonpath: 'clockInLoc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time \nOut',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'clockOutLocation',
      header: 'Clock Out \nLocation',
      jsonpath: 'clockOutLocation',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitsInHrs',
      header: 'Billed \nHours',
      jsonpath: 'billedUnitsInHrs',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Paid \nHours',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceRate',
      header: 'Service \nRate',
      jsonpath: 'serviceRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billable_rate',
      header: 'Billable \nTotal',
      jsonpath: 'billable_rate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'manualReason',
      header: 'Manual \nReason',
      jsonpath: 'manualReason',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatus',
      header: 'Business \nStatus',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'source_type_lkp',
      header: 'Timesheet \nSource',
      jsonpath: 'source_type_lkp',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'mco_name',
      header: 'Regional \nCenter',
      jsonpath: 'mco_name',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerDecisionDate',
      header: 'Decision \nTimestamp',
      jsonpath: 'consumerDecisionDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerDecisionBy',
      header: 'Decision \nBy',
      jsonpath: 'consumerDecisionBy',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  sicktime_timeoff_cols = [
    {
      field: 'serviceDate',
      header: 'Service \nDate',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceCode',
      header: 'Service \nCode',
      jsonpath: 'serviceCode',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'submissionDate',
      header: 'Submission \nDate',
      jsonpath: 'submissionDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time \nIn',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time \nOut',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitsInHrs',
      header: 'Billed \nHours',
      jsonpath: 'billedUnitsInHrs',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceRate',
      header: 'Service \nRate',
      jsonpath: 'serviceRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billableRate',
      header: 'Billable \nAmount',
      jsonpath: 'billableRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatus',
      header: 'Business \nStatus',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatus',
      header: 'Processing \nStatus',
      jsonpath: 'processingStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  constructor(
    private dateTimeFormatterService: DateTimeFormatterService,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private errorAlertService: ErrorAlertService,
    private listService: ListService,
    private sectionService: SectionsService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();

    this.programName = selectedProgram?.program_code ?? '';

    if (!this.isProviderView) {
      this.timeoff_cols.push({
        field: 'processingStatus',
        header: 'Processing \nStatus',
        jsonpath: 'processingStatus',
        isDisplayedAtHeader: 'y',
        isSearchable: 'n',
      });

      if (!this.isTimeOff) {
        this.timeoff_cols.push({
          field: 'authNum',
          header: 'Authorization \nNumber',
          jsonpath: 'authNum',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        });
      }

      if (this.isTimeOff) {
        this.timeoff_cols = [...this.sicktime_timeoff_cols];
      }
    }

    if (environment.isExternal) {
      this.timeoff_cols = this.timeoff_cols.filter(
        (col) => col.field !== 'consumerDecisionBy'
      );
    }

    this.getPayPeriod();
    this.reasonList = this.lookupService.getLookupValue('Manual Entry reason');
    this.statusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
    this.timesheetDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
    this.serviceLocations = this.lookupService.getLookupValue('service_location');
    if (!this.timeoffData) {
      this.loadRecords();
    } else {
      this.timeoffData.forEach((item: any) => {
        item.billedUnitsInHrs = item.billedUnits === 0 || item.billedUnits ? this.dateTimeFormatterService.formatUnitsToHoursMinutes(item.billedUnits) : null;
        item.paidUnits = item.paidUnits ? this.dateTimeFormatterService.formatUnitsToHoursMinutes(item.paidUnits) : null;
        if (item.createdDate) {
          item.createdDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(item.createdDate);
        }
        if (item.consumerDecisionDate) {
          item.consumerDecisionDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(item.consumerDecisionDate);
        }
        this.maskOvertimeTimeAndLocation(item);
      });
    }
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  onEdit() {
    this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeEntry');
    this.timeoffData.forEach((e: any) => {
      e.serviceTimeIn = e.timeIn;
      e.serviceTimeOut = e.timeOut;
      e.timeSheetDetailId = e.timesheetLineId;
      e.applicationStatusLkp = e.processingStatusLkp;
    });

    this.timesheetData = {
      lineItem: this.lineItem,
      serviceLines: this.timeoffData,
      payrollScheduleId: this.lineItem.masterPayrollScheduleId,
      consumer: {
        consumerId: this.lineItem.consumerId,
        consumerPplId: this.lineItem.consumerPplId,
        consumerFullName: this.lineItem.consumerName
      },
      provider: {
        providerId: this.rowData.providerId
      }
    }
    this.mode = 'edit';
    this.action = 'edit';
  }

  onCancel(event: any) {
    this.mode = 'view';
    this.action = 'view';
    if (event?.isTimesheetDeleted) {
      this.loadRecords();
    }
  }

  loadRecords() {
    const filters: { jsonPath: string; value?: any; values?: any[]; operator: string }[] = [
      {
        jsonPath: "participantId",
        value: this.lineItem.consumerId,
        operator: "Equal"
      },
      {
        jsonPath: "providerId",
        value: this.rowData.providerId,
        operator: "Equal"
      },
      {
        jsonPath: "tasMasterPayrollScheduleId",
        value: this.rowData.tasMasterPayrollScheduleId,
        operator: "Equal"
      },
      {
        jsonPath: "servicePeriodId",
        value: this.lineItem.servicePeriodId,
        operator: "Equal"
      }
    ];

    if (this.timesheetFor !== "staff" && this.rowData.businessStatus) {
      filters.push({
        jsonPath: "businessStatusLkp",
        values: [this.rowData.businessStatus, 'SPLT'],
        operator: "in"
      });
    }

    filters.push({
      jsonPath: "headerId",
      value: this.rowData.headerId ?? 0,
      operator: "Equal"
    });
    
    this.searchTimesheets(filters);
  }

  buildRequestPayload(pageName: string, searchParams: []) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchTimesheets(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'staffEditTimesheetEntry',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        this.timeoffData = this.processData(data.responsedata);
      });
  }

  handlePendedTimesheet(event: any, allowEdit: boolean) {
    this.disableEditingPendedTimesheet = this.isReadOnly ? true : allowEdit;
    const timesheetLineId = event.event.timesheetLineId;
    console.log("timesheetLineId", timesheetLineId);
    const filters: any = [
      {
        jsonPath: "timesheetId",
        value: timesheetLineId,
        operator: "Equal"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'timesheet-processCode',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.errorcodeData = data.responsedata;
        this.openPendedDialog(`${event.event.processingStatus} Timesheet`);
      });
  }

  rowClickedTs(event: any) {
    if ((event.col?.field === 'billable_rate' || event.col?.field === 'billableRate') && event.event?.timesheetLineId && event.event?.[event.col.field]) {
      this.timesheetService
        .getDerivedElements(event.event.timesheetLineId)
        .subscribe((data: any) => {
          const res = data.responsedata;
          if (!res?.taxDetail) return;
          this.derivedElementsData = {
            taxElements: Object.entries(res.taxDetail).map(([category, val]: [string, any]) => ({
              category,
              gross: val.gross,
              markup: +(val.markup * 100).toFixed(2),
              net: val.net,
            })),
            grossWage: +res.grossWage,
            taxAmount: +res.taxAmount,
            billable: +res.grossWage + +res.taxAmount,
          };
          this.openDerivedElementsDialog();
        });
    }
    else if (event.col?.field === 'authNum') {
      this.timesheetService
        .getAuthDetails(this.programName, event.event.timesheetLineId)
        .subscribe((data: any) => {
          this.authData = data.responsedata;
          this.openAuthDataDialog();
        });
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && ['Pended'].includes(event.event.processingStatus)) {
      // allow saving pended timesheets
      this.handlePendedTimesheet(event, false);
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && CommonUtil.hasInfoStatus(event.event.processingStatus)) {
      // allow do not allow edits
      this.handlePendedTimesheet(event, true);
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && event.event.processingStatus === 'Denied') {
      const payload = {
        pageName: 'timesheet-processCode',
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: 1,
        searchParam: [
          {
            jsonPath: 'timesheetId',
            value: event.event.timesheetLineId,
            operator: 'Equal',
          },
        ],
        orderByColumn: ['id'],
        orderBy: ['desc'],
      };
      this.listService
        .getListData(payload, 'claims')
        .subscribe((data: any) => {
          this.deniedData = data.responsedata;
          this.deniedData.forEach((e: any) => {
            if (e.reasonLkp) {
              e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
            }

            if (e.dispositionLkp) {
              e.disposition = this.timesheetDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
            }
          });
          this.openDeniedDialog();
        });
    }
  }


  showAuthDetails(event: any) {
    if (event.clientAuthNumber) {
      this.authDetails = event;
      this.openAuthDialog();
    }
  }

  openAuthDialog() {
    this.selectedAuthorizationId = this.authDetails.tasAuthorizationDetailId;
    const dialogConfig: DialogConfig = {
      title: `Auth Details for ${this.authDetails.clientAuthNumber}`,
      okText: 'Deny',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openPendedDialog(title: string) {
    const dialogConfig: DialogConfig = {
      title: title,
      okText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.pendedDialogId = this.dialogSvc.openDialog(
      this.pendedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openDeniedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Denied Timesheet`,
      okText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.deniedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openDerivedElementsDialog() {
    const dialogConfig: DialogConfig = {
      title: 'Service Rate Details',
      okText: 'Ok',
      size: 'large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.derivedElementsDialog,
      dialogConfig,
      () => {},
      () => {}
    );
  }

  openAuthDataDialog() {
    const dialogConfig: DialogConfig = {
      title: `Auth Data`,
      okText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDataDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  onAction(event: any) {
    if (event.action === 'editHistory') {
      this.openTimesheetEditHistoryDialog(event.data.timesheetLineId);
    }
    if (event.action === 'auditHistory') {
      this.openAuditHistoryDialog(event.data.timesheetLineId);
    }
  }

  openTimesheetEditHistoryDialog(timesheetId: number) {
    this.selectedTimesheetId = timesheetId;
    const dialogConfig: DialogConfig = {
      title: `Timesheet Edit History`,
      okText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.timesheetEditHistoryDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openAuditHistoryDialog(timesheetId: any) {
    this.selectedTimesheetId = timesheetId;
    const dialogConfig: DialogConfig = {
      title: `Timesheet Audit History`,
      okText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
      styleClass: 'split-auth-data'
    };

    this.dialogSvc.openDialog(
      this.timesheetAuthHistoryDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
    this.selectedTimesheetId = null;
  }

  rowClicked(event: any) {
    // Split entries are already loaded with the timesheet, so expanding/collapsing only toggles visibility.
    if (this.hasSplitEntries(event)) {
      event.showLineItem = !event.showLineItem;
    }
  }

  /**
   * View-mode rows: split entries (parentTimesheetLineId = a SPLT row's timesheetLineId) are nested
   * under their SPLT transaction as lineItems, shown expanded. timeoffData itself stays flat because
   * edit mode (onEdit → ppl-timesheets-add-entries) works on the full list.
   */
  get viewTimeoffData(): any[] {
    if (this.groupedTimeoffSource !== this.timeoffData) {
      this.groupedTimeoffSource = this.timeoffData;
      this.groupedTimeoffData = this.groupSplitEntries(this.timeoffData ?? []);
    }
    return this.groupedTimeoffData;
  }

  private groupSplitEntries(rows: any[]): any[] {
    const splitParents = new Map<any, any>();
    const topLevel = rows.map((row: any) => {
      if (row.businessStatusLkp !== 'SPLT') return row;
      const parent = { ...row, lineItems: [], showLineItem: true };
      splitParents.set(row.timesheetLineId, parent);
      return parent;
    });

    const grouped = topLevel.filter((row: any) => {
      const parent = splitParents.get(this.getParentTimesheetLineId(row));
      if (!parent || parent.timesheetLineId === row.timesheetLineId) return true;
      parent.lineItems.push(row);
      return false;
    });

    // A SPLT transaction with no split entries in the data has nothing to show — drop it from the view.
    return grouped.filter((row: any) => !splitParents.has(row.timesheetLineId) || row.lineItems.length > 0);
  }

  private getParentTimesheetLineId(row: any) {
    return row.parentTimesheetLineId ?? row.parent_tas_timesheetline_detail_id;
  }

  hasSplitEntries(row: any): boolean {
    return row?.businessStatusLkp === 'SPLT' && row.lineItems?.length > 0;
  }

  // ppl-list-table renders the expand icon on every row; mark flat rows so the CSS hides it.
  cellClassResolver = (row: any) => (this.hasSplitEntries(row) ? null : 'no-split-entries');

  onSaveAdjustment(event: any) {
    this.dialogSvc.closeDialog(this.pendedDialogId);
    this.pendedDialogId = null;
    this.loadRecords();
  }

  onProcessClick() {
    console.log('selectedCheckBoxValue---', this.selectedCheckBoxValue);
    if (!this.selectedCheckBoxValue?.length) {
      const errorMessage = 'Please select lines for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const totalInvalidProcessSelected = this.selectedCheckBoxValue.filter((e: any) => e.processingStatusLkp != 'PE' && e.processingStatusLkp != 'SB' && e.processingStatusLkp != 'SE');
    if (totalInvalidProcessSelected.length > 0) {
      const errorMessage = 'Please select only Pending or Submitted or System Error timesheets.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const selectedIds = this.selectedCheckBoxValue.map((item: any) => item.timesheetLineId);
    const payload =
    {
      "programCode": this.programName,
      "timesheetlineDetailIds": selectedIds
    };

    this.timesheetService.updateTimesheetAdjudication(payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.onProcessComplete.emit(data);
      }
    });
  }

  selectionChanged(event: any) {
    this.selectedCheckBoxValue = event;
  }

  processData(data: any[]) {

    data.forEach(e => {
      const businessStatus = this.statusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.businessStatusLkp;
      });

      if (businessStatus) {
        e.businessStatus = businessStatus.lkpValueName;
      }

      // mapping data back to the service location names.
      e.clockInLocation = this.serviceLocations.find((loc: LookupValueItem) => {
        return loc.lkpValueCode?.toLowerCase() === e.clockInLoc?.toLowerCase();
      })?.lkpValueName || e.clockInLoc;

      e.clockOutLocation = this.serviceLocations.find((loc: LookupValueItem) => {
        return loc.lkpValueCode?.toLowerCase() === e.clockOutLoc?.toLowerCase();
      })?.lkpValueName || e.clockOutLoc;

      const processingStatus = this.processingStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.processingStatusLkp;
      });

      if (processingStatus) {
        e.processingStatus = processingStatus.lkpValueName;
      }

      const reason = this.reasonList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.reasonLkp;
      });

      if (reason) {
        e.reason = reason.lkpValueName;
      }

      if (STATIC_DATA.STATUS_FOR_AUTH.includes(e.businessStatusLkp) || STATIC_DATA.PROCESSING_STATUS_FOR_AUTH.includes(e.processingStatusLkp)) {
        e.authNum = 'View';
      }
      e.billedUnitsInHrs = e.billedUnits === 0 || e.billedUnits ? this.dateTimeFormatterService.formatUnitsToHoursMinutes(e.billedUnits) : null;
      e.paidUnits = e.paidUnits ? this.dateTimeFormatterService.formatUnitsToHoursMinutes(e.paidUnits) : null;
      e.createdDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(e.createdDate);
      e.consumerDecisionDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(e.consumerDecisionDate);
      this.maskOvertimeTimeAndLocation(e);
    });

    data.sort((a, b) => {
      const dateA = new Date(a.serviceDate + ' ' + a.timeIn) as any;
      const dateB = new Date(b.serviceDate + ' ' + b.timeIn) as any;

      // Sorts by serviceDate and timeIn in ascending order
      return dateA - dateB;
    });

    return data;
  }

  // OTE entries are copied from the parent timesheet, so their time in/out and clock
  // locations carry no real meaning. Show them as '-' in the grid.
  private maskOvertimeTimeAndLocation(item: any) {
    if (CommonUtil.isOvertimeRow(item)) {
      item.timeIn = '-';
      item.timeOut = '-';
      item.clockInLocation = '-';
      item.clockOutLocation = '-';
    }
  }

  timesheetAdded(event: any) {
    this.timeoffData = [];
    this.loadRecords();
    this.onCancel({ isTimesheetDeleted: false });
  }


  filterPayrollDates(payrolls: any, flow: any) {
    const today = new Date();
    if (flow === 'timeEntry') {
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return startDate <= today || (today >= startDate && today <= endDate);
      });
    }
    else {
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return (startDate >= today || (today >= startDate && today <= endDate));
      });
    }
  };
}
